
import BeneficiosSolicitudCredito from "app/on-board/interfaces/ui/beneficios-solicitud";
import ComenzarCargaDocumentos from "app/on-board/interfaces/ui/comenzar-carga";
import CargaDocumentoIdentificacion from "app/carga-documentos/documento-identificacion";
import DocumentosFiscales from "app/carga-documentos/documentos-fiscales";
import FormularioInfoMaquina from "app/formulario-info-maquina/interfaces/ui/formulario-info-maquina";
import FormularioSolicitud from "app/formulario-solicitud/interfaces/ui/formulario-solicitud";
import ExtractosBancarios from "app/carga-documentos/extractos-bancarios";
import DeclaracionOrigenFondos from "app/terminos-y-condiciones/declaracion-de-origen-de-fondos";
import Autorizaciones from "app/terminos-y-condiciones/autorizaciones";
import PageError404 from "app/error-pages/error-404";
import PageError500 from "app/error-pages/error-500";
import PageErrorConnectionTimedOut from "app/error-pages/error-connection-timed-out";
import TerminosYCondicionesUsoApp from "app/terminos-y-condiciones/terminos-y-condiciones";
import SolicitudesPorRevisar from "app/analista/page-analist/interfaces/ui/page-solicitudes-por-revisar";
import CargaDocumentos from "app/on-loading/interfaces/ui/carga-documentos";
import DetalleSolicitudPorRevisar from "app/analista/detalle-solicitud/interfaces/ui/detalle-solicitud-por-revisar";
import Scoring from "app/analista/scoring/ui/pages/scoring";
import MisCreditos from "app/mis-creditos/interfaces/ui/mis-creditos";
import Login from "app/login/interfaces/ui/login";
import RecuperacionPassword from "app/login/interfaces/ui/recuperacion-password";
import PreguntasFrecuentes from "app/preguntas-frecuentes/interfaces/ui/preguntas-frecuentes";
import Unauthorized from "routes/Unauthorized";


interface RouteItem {
  path: string;
  element: JSX.Element;
}

export const PUBLIC_ROUTES: RouteItem[] = [
    { path: "/", element: <Login /> },
    { path: "/recuperacion-password", element: <RecuperacionPassword /> },
    { path: "/declaracion-de-fondos", element: <DeclaracionOrigenFondos /> },
    { path: "/autorizaciones", element: <Autorizaciones /> },
    { path: "*", element: <PageError404 /> },
    { path: "/error-500", element: <PageError500 /> },
    { path: "/error-connection-timed-out", element: <PageErrorConnectionTimedOut /> },
    { path: "/terminos-y-condiciones-uso-aplicacion", element: <TerminosYCondicionesUsoApp /> },
    { path: "/unauthorized", element: <Unauthorized /> },
];

export const ROUTES_BY_ROLE: Record<string, RouteItem[]> = {
  analist: [
    { path: "/scoring", element: <Scoring /> },
    { path: "/solicitudes-por-revisar", element: <SolicitudesPorRevisar /> },
    { path: "/detalle-solicitud-:idNumber", element: <DetalleSolicitudPorRevisar /> },
  ],
  client: [
    { path: "/beneficios-credito", element: <BeneficiosSolicitudCredito /> },
    { path: "/comenzar-carga", element: <ComenzarCargaDocumentos /> },
    { path: "/preguntas-frecuentes", element: <PreguntasFrecuentes /> },
    { path: "/preguntas-frecuentes/:productIndex", element: <PreguntasFrecuentes /> },
    { path: "/carga-documentos/:productIndex", element: <CargaDocumentos/> },
    { path: "/documento-identificacion/:productIndex", element: <CargaDocumentoIdentificacion /> },
    { path: "/documentos-fiscales/:productIndex", element: <DocumentosFiscales /> },
    { path: "/extractos-bancarios/:productIndex", element: <ExtractosBancarios /> },
    { path: "/informacion-maquina/:productIndex", element: <FormularioInfoMaquina /> },
    { path: "/formulario-solicitud/:productIndex", element: <FormularioSolicitud /> },
    { path: "/mis-creditos", element: <MisCreditos /> },
    { path: "/carga-documentos", element: <MisCreditos/> },
    { path: "/documento-identificacion", element: <MisCreditos /> },
    { path: "/documentos-fiscales", element: <MisCreditos /> },
    { path: "/extractos-bancarios", element: <MisCreditos /> },
    { path: "/informacion-maquina", element: <MisCreditos /> },
    { path: "/formulario-solicitud", element: <MisCreditos /> },
  ],
};
